import React from 'react';
import './ModularHost.sass';

export type ModularHostProps = {
  children?: JSX.Element[];
};

const ModularHost = (props: ModularHostProps) => (
  <div className="modular-host-container MuiPaper-elevation1">{props.children}</div>
);

export default ModularHost;
